<div>
    <div class="datepicker-full">
        <div class="datepicker-preselections">
            <ng-container *ngFor="let preset of periods; let first = first">
                <div class="datepicker-separator" *ngIf="!first"></div>
                <a [ngClass]="{ active: isPeriod(preset) }" (click)="onSetPeriod(preset)">{{ periodLabel(preset) | translate }}</a>
            </ng-container>
        </div>

        <div class="datepicker-datepicker">
            <app-form-datepicker-range
                name="dates"
                [min]="bounds.min"
                [max]="bounds.max"
                (dateChange)="onDateChange()"
                [(ngModel)]="dates">
            </app-form-datepicker-range>
        </div>
    </div>
</div>
